var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-label"},[_c('v-icon',{staticClass:"live-label-icon",attrs:{"size":"8"}},[_vm._v("\n    krypt-Ellipse-1\n  ")]),_vm._v(" "),_c('span',{staticClass:"live-label-text"},[_vm._v("\n        LIVE\n\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }